module.exports = __webpack_public_path__ + "img/404.02a941b2.png";